import { useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { Calendar } from "primereact/calendar";
import { AutoComplete } from "primereact/autocomplete";
import { Checkbox } from "primereact/checkbox";
import moment from "moment-timezone";
import { fullkitTaskTypes, textFieldMaxLength } from "../../../constants";
import { CharacterLimit } from "../../common/CharacterLimit/CharacterLimit";
import deleteIcon from "../../../assets/images/deleteIcon.svg";
import CalendarIcon from "../../common/CalendarIcon/CalendarIcon";
import ConfirmationDialogBox from "../../ConfirmDialog/ConfirmationDialogBox";
import { deletePopupMessage } from "../../../constants/DesignJobsConstant";
import { changeDateFormat } from "../../../utils";
import { alphanumericPattern } from "../../../constants/regex";

export default function Tasks({
  index,
  taskDetails,
  taskStatus,
  checkReadWriteAccess,
  fullkitName,
  tasks,
  setTasks,
  assigneeListOptions,
  sequenceListOptions,
  sequenceDisabledListOptions,
  handleDeleteJob,
  handleDelete,
  Design_Job_ID,
  Design_Job_Status,
  CFKDesignDisabled,
}) {

  const [filteredAssignees, setFilteredAssignees] = useState(null);
  const [filteredTypes, setFilteredTypes] = useState(null);
  const [filteredSequence, setFilteredSequence] = useState(null);
  const [visible, setVisible] = useState(false);
  const [buttonStatus, setButtonStatus] = useState("");
  const [dueDate, setDueDate] = useState(null);
  let CFKEmptyRowDisabled = !(Design_Job_Status === "");

  const completeSearchAssignee = (event) => {
    // Timeout to emulate a network connection
    setTimeout(() => {
      let _filteredaAssignees;

      if (!event.query.trim().length) {
        _filteredaAssignees = [...assigneeListOptions];
      } else {
        _filteredaAssignees = assigneeListOptions.filter((objAssignee) => { 
          return objAssignee.Person
            .toLowerCase()
            .startsWith(event.query.toLowerCase());
        });
      }

      setFilteredAssignees(_filteredaAssignees);
    }, 250);
  };

  const completeSearchSequence = (event) => {
    // Timeout to emulate a network connection
    setTimeout(() => {
      let _filteredSequence;

      if (!event.query.trim().length) {
        _filteredSequence = [...sequenceListOptions];
      } else {
        _filteredSequence = sequenceListOptions.filter((objSequence) => objSequence.seq === event.query)
      }

      setFilteredSequence(_filteredSequence);
    }, 250);
  };

  const handleDeleteButton = (index) => {
    if (Design_Job_Status === "") {
      handleDelete(index);
    } else if (Design_Job_Status === "Awaiting") {
      handleDeleteJob && handleDeleteJob(Design_Job_ID);
      handleDeleteJob && handleDelete(index);
    } else {
      setButtonStatus("Delete");
      setVisible(true);
    }
  };

  const formatIntoDatePicker = (date) => {
    const formattedDate = new Date(
      moment(date, "DD-MMM-YY")
        .tz(Intl.DateTimeFormat().resolvedOptions().timeZone)
        .format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (z)")
    );
    if (formattedDate.getFullYear() > "1999") {
      return formattedDate;
    } else {
      return "";
    }
  };

  const completeSearchType = (event) => {
    // Timeout to emulate a network connection
    setTimeout(() => {
      let _filteredTypes;

      if (!event.query.trim().length) {
        _filteredTypes = [...fullkitTaskTypes];
      } else {
        _filteredTypes = fullkitTaskTypes.filter((type) => { 
          return type
            .toLowerCase()
            .startsWith(event.query.toLowerCase());
        });
      }

      setFilteredTypes(_filteredTypes);
    }, 250);
  };

  const handleValueChange = (val, input_field_name) => {
    const tempTaskDetails = { ...taskDetails };
    switch (input_field_name) {
      case "FK_Type":
        if (val === "Confirm") {
          tempTaskDetails.Type = val;
        } else {
          tempTaskDetails.Type = "";
        }
        break;
      case "FK_Value":
        if (!alphanumericPattern.test(val)) {
          tempTaskDetails.Value = val;
        }
        break;
      case "FK_Due_Date":
        tempTaskDetails.End_Date = val;
        break;
      case "FK_Assignee":
        tempTaskDetails.Assignee = val;
        break;
      case "FK_Sequence":
        tempTaskDetails.Sequence = sequenceDisabledListOptions?.includes(val?.seq) ? "" : val;
        break;
      case "FK_FileUpload":
        tempTaskDetails.IsFileUploadMandatory = !tempTaskDetails.IsFileUploadMandatory;
        break;
      default:
        break;
    }

    let tempAllTasks = [...tasks];
    tempAllTasks.splice(index, 1, tempTaskDetails);
    setTasks(tempAllTasks);
  };

  const handleJobDelete = async () => {
    handleDeleteJob && handleDeleteJob(Design_Job_ID);
    handleDeleteJob && handleDelete(index);
    setVisible(false);
  };

  // Custom template to style the suggestion item. "Andorra" will be shown in red.
    const itemTemplate = (item) => {
        return (
            <div style={{ color: item === 'Data Check' ? '#D3D3D3' : 'inherit' }}>
                {item}
            </div>
        );
    };

  const sequenceTemplate = (item) => {
    return (
      <div style={{ color: sequenceDisabledListOptions?.includes(item?.seq) ? "#D3D3D3" : "inherit" }}>
        {item?.seq}
      </div>
    );
  };
  
  return (
    <div className="mb-4">
      <div className="fullkit-task-header">
        <span>
          {taskDetails.Type || "Type"}_FK_{fullkitName}_{taskDetails.Value || "Value"}
        </span>
        <span>
          <img
            src={deleteIcon}
            alt="delete tasks"
            onClick={() => checkReadWriteAccess && taskStatus !== "Complete" && handleDeleteButton(index)}
            className="header-icons"
            disabled={!checkReadWriteAccess && taskStatus !== "Complete"}
          />
        </span>
      </div>
      <Row className="fullkit-task-details">
        <Col>
          <Form.Group>
            <Form.Label>
              Type <sup>*</sup>
            </Form.Label>
            <AutoComplete
              id={`type-${index}`}
              disabled={CFKDesignDisabled && CFKEmptyRowDisabled}
              value={taskDetails.Type}
              suggestions={filteredTypes}
              completeMethod={completeSearchType}
              forceSelection
              onChange={(e) => handleValueChange(e.value, "FK_Type")}
              dropdown
              itemTemplate={itemTemplate}
            />
          </Form.Group>
        </Col>
        <Col>
          <div className="d-flex flex-column">
            <label htmlFor={`value-${index}`}>
              Value <sup>*</sup>
            </label>
            <input
              id={`value-${index}`}
              type="text"
              maxLength={textFieldMaxLength}
              className="form-control font-size-10 taskValueInput"
              onChange={(e) => handleValueChange(e.target.value, "FK_Value")}
              value={taskDetails.Value}
              disabled={CFKDesignDisabled && CFKEmptyRowDisabled}
            />
            {(taskDetails.Value === "" || taskDetails.Value === undefined) && (
              <span className="error-text-di">Field Remaining</span>
            )}{" "}
          </div>
          <CharacterLimit field={taskDetails.Value} maxLength={textFieldMaxLength} />
        </Col>
        <Col>
          <Form.Group>
            <Form.Label>
              Due Date <sup>*</sup>
            </Form.Label>
            <Calendar
              id={`due-date-${index}`}
              disabled={CFKDesignDisabled && CFKEmptyRowDisabled}
              minDate={new Date()}
              dateFormat="d-M-y"
              value={
                taskDetails?.EndDate
                  ? formatIntoDatePicker(changeDateFormat(taskDetails?.EndDate))
                  : dueDate
              }
              onChange={(e) => {
                setDueDate(e.value);
                handleValueChange(e.value, "FK_Due_Date");
              }}
              icon={<CalendarIcon />}
              showIcon={true}
            />
          </Form.Group>
        </Col>
        <Col>
          <Form.Group>
            <Form.Label>
              Assignee <sup>*</sup>
            </Form.Label>
            <AutoComplete
              field="Person"
              disabled={CFKDesignDisabled && CFKEmptyRowDisabled}
              id={`assignee-${index}`}
              value={taskDetails.Assignee}
              forceSelection
              suggestions={filteredAssignees}
              completeMethod={completeSearchAssignee}
              onChange={(e) => {
                handleValueChange(e.value, "FK_Assignee");
              }}
              dropdown
            />
          </Form.Group>
        </Col>
        <Col md={1}>
          <Form.Group>
            <Form.Label>Sequence <sup>*</sup></Form.Label>
            <AutoComplete
              field="seq"
              disabled={CFKDesignDisabled && CFKEmptyRowDisabled}
              id={`sequence-${index}`}
              value={taskDetails.Sequence}
              forceSelection
              suggestions={filteredSequence}
              completeMethod={completeSearchSequence}
              onChange={(e) => handleValueChange(e.value, "FK_Sequence")}
              dropdown
              itemTemplate={sequenceTemplate}
            />
          </Form.Group>
        </Col>
        <Col className="d-flex align-items-center">
          <Form.Group>
            <Checkbox
              inputId={`file_upload-${index}`}
              checked={taskDetails.IsFileUploadMandatory}
              onChange={(e) => handleValueChange(null, "FK_FileUpload")}
              disabled={CFKDesignDisabled && CFKEmptyRowDisabled}
            />
            <label htmlFor={`file_upload-${index}`} className="mandatory-file-upload">
              Mandatory File Upload
            </label>
          </Form.Group>
        </Col>
      </Row>
      {buttonStatus === "Delete" && visible && (
        <ConfirmationDialogBox
          visible={visible}
          onHide={setVisible}
          message={<>{deletePopupMessage}</>}
          icon="pi"
          handleContinue={() => {
            handleJobDelete();
          }}
          handleCancel={() => {
            setVisible(false);
          }}
        />
      )}
    </div>
  );
}
